export function Logo({ light = false, size = "md", className = "" }) {
  const scale = {
    sm: "text-2xl",
    md: "text-3xl",
    lg: "text-5xl",
    xl: "text-7xl",
  }[size];
  const baseColor = light ? "text-white" : "text-[#0A0A0A]";
  return (
    <span
      className={`font-display font-black tracking-tight uppercase leading-none ${scale} ${baseColor} ${className}`}
      aria-label="DTA. Down. Test. Adjust."
    >
      <span>D</span>
      <span style={{ color: "#031D47" }}>TES</span>
      <span>T</span>
      <span style={{ color: "#031D47" }}>A</span>
      {/* Above: D + TES (navy) + T + A (navy) reads as D-T-E-S-T-A ≈ DTA with TEST accent.
          Compact wordmark: 'D' 'TEST' 'A' but display-run keeps single word */}
    </span>
  );
}

export function LogoMark({ light = false, className = "" }) {
  return (
    <img
      src="/brand/dta-logo.webp"
      alt="DTA. Down. Test. Adjust."
      className={`h-10 md:h-14 w-auto object-contain select-none ${
        light ? "" : "invert"
      } ${className}`}
      draggable={false}
    />
  );
}
